import { Component } from '@angular/core';
import { Icon } from '../icon/icon.component';
import { ModalBasement } from './modal.adapter';

@Component({
  selector: 'app-modal-header',
  template: `
    <section
      class="z-10 flex justify-between w-full px-4 bg-white border-b border-gray-100"
    >
      <div
        class="flex relative gap-2 items-center h-12 w-full justify-between font-semibold"
      >
        <div
          (click)="close()"
          class="cursor-pointer size-8 rounded-full bg-zinc-100 flex items-center justify-center"
        >
          <app-icon
            name="material-symbols-light:chevron-left-rounded"
            class="text-gray-400"
            size="lg"
          />
        </div>
        <p class="font-medium text-gray-800 md:text-lg">
          <ng-content />
        </p>
        <p></p>
      </div>
      <ng-content select="[icons]" />
    </section>
  `,
  imports: [Icon],
})
export class ModalHeader extends ModalBasement {}
